"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var _recompose = require("recompose");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _polished = require("polished");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _recompose.compose)((0, _recompose.setPropTypes)({
  text: _propTypes.default.string.isRequired
}), (0, _recompose.setDisplayName)('HideText'))(function (_ref) {
  var text = _ref.text;
  return (0, _core.jsx)("span", {
    css: (0, _polished.hideVisually)()
  }, text);
});

exports.default = _default;